module.exports = __webpack_public_path__ + "img/161.90e0bea4.png";